import Chart, { ChartEvent, Plugin } from 'chart.js/auto';

type YAxisOptions = {
    lineWidth: number;
    strokeStyle: string;
    fillStyle: string;
    textColor: string;
    format: Function;
    order?: 'before' | 'after';
    dash?: [number, number];
};

export const Y_AXIS_LINE_PLUGIN: Plugin<'bar' | 'line'> = {
    id: 'yAxisLine',
    defaults: {
        lineWidth: 1,
        strokeStyle: '#525860',
        fillStyle: '#17191c',
        textColor: '#fff',
        format: (value: string) => value,
        order: 'before'
    } as YAxisOptions,
    afterInit: (chart: Chart): void => {
        // @ts-expect-error expected ignore
        chart.yAxisLine = {
            x: 0
        };
    },
    afterEvent: (
        chart: Chart,
        args: { event?: ChartEvent; inChartArea?: boolean }
    ): void => {
        const { inChartArea } = args;
        const { x } = args.event!;

        // @ts-expect-error expected ignore
        chart.yAxisLine = { x, draw: inChartArea };
        chart.draw();
    },
    beforeDatasetsDraw: (chart: Chart, _: never, options: YAxisOptions): void => {
        if (options.order !== 'before') return;

        draw(chart, _, options);
    },
    afterDatasetsDraw: (chart: Chart, _: never, options: YAxisOptions): void => {
        if (options.order !== 'after') return;

        draw(chart, _, options);
    }
};

function draw(chart: Chart, _: never, options: YAxisOptions): void {
    const { ctx } = chart;
    const { top, bottom } = chart.chartArea;
    // @ts-expect-error expected ignore
    if (!chart.yAxisLine) return;
    // @ts-expect-error expected ignore
    const { x, draw } = chart.yAxisLine;
    if (!draw) return;

    ctx.save();

    ctx.beginPath();
    ctx.lineWidth = options.lineWidth;
    ctx.strokeStyle = options.strokeStyle;
    if (options.dash) ctx.setLineDash(options.dash);
    ctx.moveTo(x, bottom);
    ctx.lineTo(x, top);
    ctx.stroke();

    const LABEL: string = options.format(
        // @ts-expect-error expected ignore
        `${chart.config.data.labels[chart.tooltip?._active[0]?.index] || ''}`
    );
    if (!LABEL) {
        ctx.restore();
        return;
    }
    const BOTTOM: number = bottom + 20;
    const PADDING: number = 8;
    const WIDTH: number = ctx.measureText(LABEL).width + PADDING * 2;

    ctx.fillStyle = options.fillStyle;
    ctx.fillRect(x - WIDTH / 2, BOTTOM - PADDING, WIDTH, 10 + PADDING * 2);

    ctx.textBaseline = 'top';
    ctx.textAlign = 'center';
    ctx.fillStyle = options.textColor;
    ctx.fillText(LABEL, x, BOTTOM);

    ctx.restore();
}
